// extracted by mini-css-extract-plugin
module.exports = {"pageLoading":"UKPageLoading_pageLoading__NixmT","pageLoadingContent":"UKPageLoading_pageLoadingContent__4pFUa","text":"UKPageLoading_text__ZS9h2"};